export default "__VITE_ASSET__BD_bXwP0__"